export default __webpack_public_path__ + "static/media/PlayerStorage.256.b6c71f57.png";